export default "__VITE_ASSET__7_qdeNox__"